module.exports = __webpack_public_path__ + "static/media/logoJp.640bb0a4.svg";